import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import * as firebase from 'firebase/compat/app';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FirebaseFunctionsService {

  constructor(private auth: AngularFireAuth, private afs: AngularFirestore, private afStrore: AngularFireStorage, private route: Router) { }
  getInfos(){
    return this.afs.collection('infos').get();
  }
  getImgUrlFromFireStorage(path: string){
    return this.afStrore.ref(path).getDownloadURL();
  }
  getProfilePicture(userId){
    return this.afStrore.ref(`/utilisateurs/${userId}/profilePicture`).listAll();
  }
  createEvents(uid: string, dateStart: Date, dateEnd: Date, name: string){
    this.afs.collection('evenements').add({
      'dateStart': dateStart,
      'dateEnd': dateEnd,
      'name': name,
      'isActive': false,
      'evenementId': '',
      'createdBy': uid
    }).then( (ev) => {
      ev.update({
        'evenementId': ev.id
      });
      this.showMessage(1,`L'évènement '${name}' a été crée.`, 5000);
    }).catch( () => {
      this.showMessage(3, 'Il y a eu un problème lors de la création de l\'évènement. Réesayer plus tard', 5000);
    })
  }
  modifyEvents(eventId: string, dateDebut: Date, dateFin: Date){
    this.afs.collection('evenements').doc(eventId).update({
      dateStart: dateDebut,
      dateEnd: dateFin
    }).then((ev)=>{
      this.showMessage(1,`La date de début et de fin d'évènement ont été modifiés.`, 5000);
    }).catch(()=> {
      this.showMessage(3, 'Il y a eu un problème lors de la modification des dates de l\'évènement. Réesayer plus tard.', 5000);
    })
  }
  deleteEvent(eventId: string){
    return this.afs.collection('evenements').doc(eventId).delete().then( ()=> true).catch(() => false);
  }
  getEventById(eventId: string){
    return this.afs.collection('evenements').doc(eventId).get();
  }
  getAllEvents(){
    return this.afs.collection('evenements', ref => ref.orderBy('dateStart', 'asc')).get();
  }
  uploadUserProfileImg(path: string, file: any){
    return this.afStrore.upload(path,file);
  }
  getUtilisateur(userId: string){
    return this.afs.collection('utilisateurs').doc(userId).valueChanges();
  }
  getUtilisateur2(userId: string){
    return this.afs.collection('utilisateurs').doc(userId).get();
  }
  getUtilisateursTemps(){
    return this.afs.collection('etoiles_sf').valueChanges();
  }
  getAllUsers(){
    return this.afs.collection('utilisateurs', ref => ref.orderBy('medailles_count', 'desc')).valueChanges();
  }
  getUsersByTemps(debut: Date){
    const dateDebut = new Date(debut);
    const debutTimeStanp = firebase.default.firestore.Timestamp.fromDate(dateDebut);
    return this.afs.collection('etoiles', ref => ref.where('created', '>=', debutTimeStanp)).valueChanges()
  }
  getUserTemps(userId: string, debut: Date, fin: Date){
    return this.afs.collection('etoiles', ref=> ref.where('userId', '==', userId)).get();
  }
  getUsersTemps(debut: Date, fin: Date, tBodyClass: string){
    const tBody = (document.querySelector(tBodyClass) as HTMLElement);
    this.afs.collection('etoiles_sf').get().forEach( users => {
      let tr;let tdPrenom; let tdNom; let tdSeul; let tdFamille; let tdClasse; let tdTotal;let tdClass;let divClass;
      users.docs.forEach(  user => {
        let count = 0;
        this.getUtilisateur2(user.id).forEach(userdata => {
          if(userdata.data()['typeUtilisateur'] != 'administrateur'){
            tr = document.createElement('tr');
            tdPrenom = document.createElement('td');tdPrenom.style.width = '10%';
            tdPrenom.innerHTML = userdata.data()['prenom']; tr.appendChild(tdPrenom);
            tdNom = document.createElement('td');tdNom.style.width = '10%';
            tdNom.innerHTML = userdata.data()['nom']; tr.appendChild(tdNom);
            tdSeul = document.createElement('td');tdSeul.style.width = '5%';
            tdFamille = document.createElement('td');tdFamille.style.width = '5%';
            tdClasse = document.createElement('td');tdClasse.style.width = '5%';
            tdClasse.innerHTML = 'temp';
            tdTotal = document.createElement('td');tdTotal.style.width = '5%';
            tdClass = document.createElement('td');
            tdClass.style.cssText = 'width:20%;white-space:nowrap; position:relative;height:100%';
            divClass = document.createElement('div');
            divClass.style.cssText = 'width: 15vw;overflow-x:hidden;text-overflow: ellipsis';
            let seul = 0; let famille = 0;let classes = 0;
            this.getUserTemps(user.id,debut, fin).forEach( temps => {
              temps.docs.forEach( temp => {
                const date = new Date(temp.data()['created'].seconds * 1000);
                const dateDebut = new Date(debut);
                let dateFin = new Date(fin);
                dateFin.setDate(dateFin.getDate() + 1);
                if(date >= dateDebut && date < dateFin && temp.data()['evenementId'] != ''){
                  if(temp.data()['type'] == 1){
                    seul = seul + temp.data()['nbrEtoiles'];
                  }else if(temp.data()['type'] == 2){
                    famille = famille + temp.data()['nbrEtoiles'];
                  }else{
                    classes = classes + temp.data()['nbrEtoiles'];
                  }
                }
              });
              tdSeul.innerHTML = seul?.toFixed(1);tr.appendChild(tdSeul);
              tdFamille.innerHTML = famille?.toFixed(1);tr.appendChild(tdFamille);
              tdClasse.innerHTML = classes?.toFixed(1);tr.appendChild(tdClasse);
              tdTotal.innerHTML = (seul + famille + classes)?.toFixed(1);tr.appendChild(tdTotal);
              for (const clas of userdata.data()['classes']) {
                this.afs.collection('classes').doc(clas).get().forEach( cls => {
                  const b = document.createElement('b');
                  b.style.fontWeight = '400';
                  if(divClass.innerHTML == ''){
                    b.innerHTML =  cls.data()['nom']; divClass.appendChild(b);
                  }else{
                    b.innerHTML =  `,${cls.data()['nom']}`; divClass.appendChild(b);
                  }
                });
              }
              tdClass.appendChild(divClass);
              tr.appendChild(tdClass);
              if( userdata.data()['ecole_id'] != ''){
                this.afs.collection('ecoles').doc(userdata.data()['ecole_id']).get().forEach( ecole => {
                  const userSchoolName = ecole.data()['nom'];
                  const tdEcole = document.createElement('td');
                  tdEcole.style.width = '20%';
                  tdEcole.innerHTML = userSchoolName; tr.appendChild(tdEcole);
                  this.afs.collection('regions').doc(ecole.data()['region_id']).get().forEach( region => {
                    const userRegionName = region.data()['nom'];
                    const tdRegion = document.createElement('td');
                    tdRegion.style.width = '20%';
                    tdRegion.innerHTML = userRegionName; tr.appendChild(tdRegion);
                  });
                })
              }
            });
            tBody.appendChild(tr);
          }
          count++;
        });
        (document.querySelector('.research_result') as HTMLParagraphElement).innerHTML = `${count} resultats obtenus`;
      });
    });
  }
  getClasses(tBodyClass: string){
    const tableBody = document.querySelector(tBodyClass) as HTMLElement;
    this.afs.collection('classes',ref => ref.orderBy('medailles_count', 'desc')).get().subscribe( classes  => {
      classes.docs.forEach( clas => {
        let tr = document.createElement('tr');
        this.afs.collection('ecoles').doc(clas.data()['ecole_id']).get().subscribe( ecole => {
          this.afs.collection('regions').doc(ecole.data()['region_id']).get().subscribe( region => {
            const tdNom = document.createElement('td');
            tdNom.innerHTML = clas.data()['nom'];tr.appendChild(tdNom);
            const tdNbrStudent = document.createElement('td');
            tdNbrStudent.innerHTML = clas.data()['eleves_id'].length;tr.appendChild(tdNbrStudent);
            const tdStar = document.createElement('td');
            tdStar.innerHTML = clas.data()['medailles_count']?.toFixed(1);tr.appendChild(tdStar);
            const tdNiveau = document.createElement('td');
            tdNiveau.innerHTML = clas.data()['niveau'];tr.appendChild(tdNiveau);
            const tdSchool = document.createElement('td');
            tdSchool.innerHTML = ecole.data()['nom'];tr.appendChild(tdSchool);
            const tdRegion = document.createElement('td');
            tdRegion.innerHTML = region.data()['nom'];tr.appendChild(tdRegion);
          });
        });
        (document.querySelector('.research_result') as HTMLElement).innerHTML = `${classes.size} resultats obtenus`;
        tableBody.appendChild(tr);
      });
    });
  }
  getClasseTemps(cdc: string){
    return this.afs.collection('etoiles', ref=> ref.where('classeId', '==', cdc)).get();
  }
  getClassesTemps(debut: Date, fin: Date, tBodyClass: string){
    const tableBody = document.querySelector(tBodyClass) as HTMLElement;
    this.afs.collection('etoiles_classes').get().forEach( classes => {
      let classesCount = 0;
      classes.docs.forEach(clas => {
        let tr = document.createElement('tr');
        this.getClasseTemps(clas.id).forEach(temps => {
          let etoiles = 0;
          if(temps.size > 0){
            temps.docs.forEach( temp => {
              const date = new Date(temp.data()['created'].seconds * 1000);
              const dateDebut = new Date(debut);
              let dateFin = new Date(fin);
              dateFin.setDate(dateFin.getDate() + 1);
              if(date >= dateDebut && date < dateFin && temp.data()['evenementId'] != ''){
                if(temp.data()['type'] == 3){
                  etoiles = etoiles + temp.data()['nbrEtoiles'];
                }
              }
            });
            this.afs.collection('classes').doc(clas.id).get().forEach(cls => {
              this.afs.collection('ecoles').doc(cls.data()['ecole_id']).get().subscribe( ecole => {
                this.afs.collection('regions').doc(ecole.data()['region_id']).get().subscribe( region => {
                  const tdNom = document.createElement('td');
                  tdNom.innerHTML = cls.data()['nom'];tr.appendChild(tdNom);
                  const tdNbrStudent = document.createElement('td');
                  tdNbrStudent.innerHTML = cls.data()['eleves_id'].length;tr.appendChild(tdNbrStudent);
                  const tdStar = document.createElement('td');
                  tdStar.innerHTML = etoiles?.toFixed(1);tr.appendChild(tdStar);
                  const tdNiveau = document.createElement('td');
                  tdNiveau.innerHTML = cls.data()['niveau'];tr.appendChild(tdNiveau);
                  const tdSchool = document.createElement('td');
                  tdSchool.innerHTML = ecole.data()['nom'];tr.appendChild(tdSchool);
                  const tdRegion = document.createElement('td');
                  tdRegion.innerHTML = region.data()['nom'];tr.appendChild(tdRegion);
                });
              });
            });
            classesCount++;
          }
        });
        tableBody.appendChild(tr);
      });
      (document.querySelector('.research_result') as HTMLElement).innerHTML = `${classesCount} resultats obtenus`;
    });
  }
  getActiveEvents2(){
    return this.afs.collection('evenements', ref => ref.where('isActive', '==', true)).get().toPromise();
  }
  getActiveEventId(){
    return this.afs.collection('evenements', ref => ref.where('isActive', '==', true)).get();
  }
  getEtoilesByEvtId(evtId: string){
    return this.afs.collection('etoiles', ref => ref.where('evenementId','==', evtId)).get();
  }
  getUserStarTemps(userId: string){
    return this.afs.collection('etoiles_sf').doc(userId).valueChanges();
  }
  getEcole(ecoleId: string){
    return this.afs.collection('ecoles').doc(ecoleId).valueChanges();
  }
  getAllEcoles(){
    return this.afs.collection('ecoles').get();
  }
  getEcoleName(ecoleId: string){
    return this.afs.collection('ecoles').doc(ecoleId).get();
  }
  getSchoolTemps(schoolId: string){
    return this.afs.collection('etoiles', ref => ref.where('ecoleId','==', schoolId)).get();
  }
  getClasseName(cdc: string){
    return this.afs.collection('classes').doc(cdc).valueChanges();
  }
  getUsers(tBodyClass: string){
    const tableBody = document.querySelector(tBodyClass) as HTMLElement;
    this.afs.collection('utilisateurs', ref => ref.orderBy('medailles_count', 'desc')).get().subscribe( users => {
      users.docs.forEach( user => {
        let tr = document.createElement('tr');
        const tdPrenom = document.createElement('td');
        tdPrenom.style.width = '10%';
        tdPrenom.innerHTML = user.data()['prenom'];tr.appendChild(tdPrenom);
        const tdNom = document.createElement('td');
        tdNom.style.width = '10%';
        tdNom.innerHTML = user.data()['nom'];tr.appendChild(tdNom);
        const tdSeul = document.createElement('td');
        tdSeul.style.width = '5%';
        tdSeul.innerHTML = user.data()['etoiles_seul']?.toFixed(1);tr.appendChild(tdSeul);
        const tdFamille = document.createElement('td');
        tdFamille.style.width = '5%';
        tdFamille.innerHTML = user.data()['etoiles_famille']?.toFixed(1);tr.appendChild(tdFamille);
        const tdClasse = document.createElement('td');
        tdClasse.style.width = '5%';
        tdClasse.innerHTML = user.data()['etoiles_class']?.toFixed(1);tr.appendChild(tdClasse);
        const tdTotal = document.createElement('td');
        tdTotal.style.width = '5%';
        tdTotal.innerHTML = user.data()['medailles_count']?.toFixed(1);tr.appendChild(tdTotal);
        const tdClass = document.createElement('td');
        tdClass.style.cssText = 'width:20%;white-space:nowrap; position:relative;height:100%';
        const divClass = document.createElement('div');
        divClass.style.cssText = 'width: 15vw;overflow-x:hidden;text-overflow: ellipsis';
        for (const clas of user.data()['classes']) {
          this.afs.collection('classes').doc(clas).get().subscribe( cls => {
            const b = document.createElement('b');
            b.style.fontWeight = '400';
            if(divClass.innerHTML == ''){
              b.innerHTML =  cls.data()['nom']; divClass.appendChild(b);
            }else{
              b.innerHTML =  `,${cls.data()['nom']}`; divClass.appendChild(b);
            }
          });
        }
        tdClass.appendChild(divClass);
        tr.appendChild(tdClass);
        if( user.data()['ecole_id'] != ''){
          this.afs.collection('ecoles').doc(user.data()['ecole_id']).get().subscribe( ecole => {
            const userSchoolName = ecole.data()['nom'];
            const tdEcole = document.createElement('td');
            tdEcole.style.width = '20%';
            tdEcole.innerHTML = userSchoolName; tr.appendChild(tdEcole);
            this.afs.collection('regions').doc(ecole.data()['region_id']).get().subscribe( region => {
              const userRegionName = region.data()['nom'];
              const tdRegion = document.createElement('td');
              tdRegion.style.width = '20%';
              tdRegion.innerHTML = userRegionName; tr.appendChild(tdRegion);
            });
          })
        }
        tableBody.appendChild(tr);
      });
    })
  }
  getEcolesByRegion(regionId: string){
    return this.afs.collection('ecoles', ref => ref.where('region_id', '==', regionId)).valueChanges();
  }
  getRegion(regionId: string){
    return this.afs.collection('regions').doc(regionId).valueChanges();
  }
  getAllRegions(){
    return this.afs.collection('regions').get();
  }
  getClasseById(classeId: string){
    return this.afs.collection('classes').doc(classeId).valueChanges();
  }
  getEnseignantClasses(enseignantId: string){
    return this.afs.collection('classes', ref => ref.where('responsable_id', '==', enseignantId)).valueChanges();
  }
  getParticipantClasses(participantId: string){
    return this.afs.collection('classes', ref => ref.where('eleves_id', 'array-contains', participantId)).valueChanges();
  }
  getActivities(){
    return this.afs.collection('activites', ref => ref.orderBy('no')).valueChanges();
  }
  getActivityById(activityId){
    return this.afs.collection('activites').doc(activityId).valueChanges();
  }
  getRegionByProvince(province){
    return this.afs.collection('regions', ref => ref.where('province', '==', province).orderBy('nom','asc')).valueChanges();
  }
  createUtilisateur(
    courriel: string, password: string, userName: string,
    ecoleId: string, lastname: string, firstname: string,
    type: string, classeArr: string[]){
      return this.auth.createUserWithEmailAndPassword(courriel, password).then( res => {
        res.user.updateProfile({displayName: userName});
        return this.afs.collection('utilisateurs').doc(res.user.uid).set({
          classes: classeArr,
          ecole_id: ecoleId,
          email: courriel,
          cumul_par_activites: {},
          etoiles_class: 0,
          etoiles_famille: 0,
          etoiles_seul: 0,
          medailles_count: 0,
          nom: lastname,
          prenom: firstname,
          typeUtilisateur: type,
          userId: res.user.uid,
          username: userName
        }).then( () => {
          this.afs.collection('etoiles_sf').doc(res.user.uid).set({
            etoiles_famille: 0,
            etoiles_seul: 0,
            medailles_count: 0,
            userId: res.user.uid
          });
          this.auth.signOut();
          this.showMessage(1, 'Utilisateur ' + userName + ' enregistré.', 3000);
          return res.user.uid;
        });
      }).catch( err => {
        if (err.code == 'auth/email-already-in-use'){
          this.showMessage(3, 'Cet adresse courriel est déjà en utilisation.', 3000);
        }
        return {code: 'auth/non-creer', message: 'Utilisateur non créer.'};
      });
  }
  createUtilisateurByCdc(courriel: string, password: string, username: string, codeClasse: string, lastname: string, firstname: string){
    this.afs.collection('classes').doc(codeClasse).get().forEach( cl => {
      this.createUtilisateur(courriel, password, username, cl.data()['ecole_id'], lastname, firstname, 'participant', [codeClasse]).then( res => {
        this.afs.collection('classes').doc(codeClasse).update({
          eleves_id: firebase.default.firestore.FieldValue.arrayUnion(res)
        });
      }).catch( err => {
        console.dir(err);
      });
    });
  }
  joinClasse(classeId: string, userId: string){
    this.afs.collection('classes').doc(classeId).update({
      eleves_id: firebase.default.firestore.FieldValue.arrayUnion(userId)
    }).then( () => {
      this.afs.collection('utilisateurs').doc(userId).update({
        classes: firebase.default.firestore.FieldValue.arrayUnion(classeId)
      }).then( () => {
        this.getClasseById(classeId).forEach( res => {
          this.showMessage(1, `Vous avez rejoins la classe ${res['nom']}.`, 3000);
        })
      }).catch( () => {
        this.showMessage(3, 'Vous n\'avez pas les permissions de modifier ces données.', 3000);
      })
    }).catch( err => console.dir(err))
  }
  addClasse(userId: string, className: string, classeLevel: string[]){
    this.afs.collection('classes', ref => ref.where('nom', '==', className).where('responsable_id','==',userId)).get().subscribe( res => {
      if(res.docs.length == 0){
        let classeLevelString = '';
        classeLevel.forEach( level => {
          if(classeLevel.indexOf(level) < classeLevel.length && classeLevel.indexOf(level) != 0){
            classeLevelString = classeLevelString + ',';
          }
          classeLevelString = classeLevelString + level.toString();
          let cdcPostCode = Math.random().toString(36).slice(2).substr(0,12);
          while (cdcPostCode.length < 12 || cdcPostCode == undefined) {
            cdcPostCode = Math.random().toString(36).slice(2).substr(0,12);
          }
          const cdc = 'cdc'+ cdcPostCode;
          this.afs.collection('utilisateurs').doc(userId).get().forEach( user => {
            this.afs.collection('classes').doc(cdc).set({code_ref:cdc, ecole_id:user.data()['ecole_id'],
              eleves_id: [], medailles_count: 0, niveau: classeLevelString, nom: className, responsable_id: userId
            });
          });
          this.afs.collection('utilisateurs').doc(userId).update({
            classes: firebase.default.firestore.FieldValue.arrayUnion(cdc)
          }).then( () => {
            this.afs.collection('etoiles_classes').doc(cdc).set({
              classeId: cdc,
              etoiles_class: 0,
              medailles_count: 0
            });
            this.showMessage(1, `La classe ${className} a été ajouté.`,3000);
          }).catch( ()=> {
            this.showMessage(3,'Nous n\'avons pas pu ajouté la classe. Réessayer plutard.',3000);
          });
        });
      }else{
        this.showMessage(3, 'Vous avez déjà une classe de ce nom. Veuillez choissir un autre nom', 3000);
      }
    });
  }
  addClasse2(userId: string, className: string, classeLevel: string[]){
    this.afs.collection('classes', ref => ref.where('nom','==',className).where('responsable_id','==',userId)).get().subscribe( classes => {
      if(classes.size <= 0){
        const classesLevelString = classeLevel.join();
        let cdcPostCode = Math.random().toString(36).slice(2).substr(0,12);
        while (cdcPostCode.length < 12 || cdcPostCode == undefined) {
          cdcPostCode = Math.random().toString(36).slice(2).substr(0,12);
        }
        const cdc = 'cdc'+ cdcPostCode;
        this.afs.collection('classes').doc(cdc).set(
          {code_ref:cdc,ecole_id:'',eleves_id: [],medailles_count: 0,niveau: classesLevelString,nom: className,responsable_id: userId})
          .then( () => {
            this.afs.collection('utilisateurs').doc(userId).update({classes: firebase.default.firestore.FieldValue.arrayUnion(cdc)})
            .then( () => {
              this.getUtilisateur2(userId).subscribe(userData => {
                this.afs.collection('classes').doc(cdc).update({ecole_id: userData.data()['ecole_id']}).then( () => {
                  this.showMessage(1, `La classe ${className} a été ajouté.`,3000);
                });
              });
            });
          });
      }else{
        this.showMessage(3, 'Vous avez déjà une classe de ce nom. Veuillez choissir un autre nom', 3000);
      }
    });
  }
  isClasseExists(classeId: string){
    return this.afs.collection('classes').doc(classeId).get();
  }
  /** Afficher les messages(reusitte, avertissement ou erreur) partout dans l'app */
  showMessage(typeMsg: number, msg: string, duree: number): void{
    if (msg != '' && (typeMsg > 0 && typeMsg < 4) && duree > 1000){
      const appMessage = document.createElement('div');
      if (typeMsg == 1){
        appMessage.classList.add('appMsg');
        appMessage.classList.add('appMsg_success');
      }else if (typeMsg == 2){
        appMessage.classList.add('appMsg');
        appMessage.classList.add('appMsg_avertissement');
      }else{
        appMessage.classList.add('appMsg');
        appMessage.classList.add('appMsg_error');
      }
      const pMsg = document.createElement('p');
      pMsg.innerHTML = msg;
      appMessage.appendChild(pMsg);
      document.body.appendChild(appMessage);
      setTimeout( () => {
        document.body.removeChild(appMessage);
      }, duree);
    }
  }
  addEtoiles(uid: string, clsId: string, etoilesCount: number, activiteId: string, choice: number, eventId: string){
    const today = new Date();
    this.afs.collection('etoiles').add({
      activityId: activiteId,
      classeId: clsId,
      ecoleId: '',
      created: firebase.default.firestore.Timestamp.fromDate(today),
      evenementId: eventId,
      nbrEtoiles: etoilesCount,
      userId: uid,
      type: choice
    }).then((res) => {
      this.afs.collection('utilisateurs').doc(uid).get().subscribe(userData => {
        res.update({
          ecoleId: userData.data()['ecole_id']
        });
      });
      if(choice == 1){
        this.afs.collection('etoiles_sf').doc(uid).update({
          etoiles_seul: firebase.default.firestore.FieldValue.increment(etoilesCount),
          medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount)
        });
      }else if (choice == 2){
        this.afs.collection('etoiles_sf').doc(uid).update({
          etoiles_famille: firebase.default.firestore.FieldValue.increment(etoilesCount),
          medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount)
        });
      }else{
        this.afs.collection('etoiles_classes').doc(clsId).update({
          etoiles_class: firebase.default.firestore.FieldValue.increment(etoilesCount),
          medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount)
        });
      }
    }).catch(() => {
      this.showMessage(3,'Désole, nous avons eu un problème lors de l\'enregistrement des étoiles. Veuillez entrer à nouveau vos minutes. Merci.', 5000);
    });
  }
  updateStarsForUser(userId: string, etoilesCount: number, choice: string, activityId: string): void{
    if (choice == '1'){
      this.afs.collection('utilisateurs').doc(userId).update({
        etoiles_seul: firebase.default.firestore.FieldValue.increment(etoilesCount),
        ['cumul_par_activites.' + activityId]: firebase.default.firestore.FieldValue.increment(etoilesCount),
        medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount)
      }).then( () => {
        if (etoilesCount > 1){
          this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoiles`, 3000);
        }else{
          this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoile`, 3000);
        }
      });
      this.updateTempForUser(userId,'',etoilesCount,choice,activityId);
    }else{
      if(choice == '2'){
        this.afs.collection('utilisateurs').doc(userId).update({
          etoiles_famille: firebase.default.firestore.FieldValue.increment(etoilesCount),
          ['cumul_par_activites.' + activityId]: firebase.default.firestore.FieldValue.increment(etoilesCount),
          medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount)
        }).then( () => {
          if (etoilesCount > 1){
            this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoiles`, 3000);
          }else{
            this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoile`, 3000);
          }
        });
        this.updateTempForUser(userId,'',etoilesCount,choice,activityId);
      }else{
        this.afs.collection('utilisateurs').doc(userId).update({
          etoiles_class: firebase.default.firestore.FieldValue.increment(etoilesCount),
          ['cumul_par_activites.' + activityId]: firebase.default.firestore.FieldValue.increment(etoilesCount),
          medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount)
        }).then( () => {
          if (etoilesCount > 1){
            this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoiles`, 3000);
          }else{
            this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoile`, 3000);
          }
        });
      }
    }
  }
  updateTempForUser(userId: string,classId: string, etoilesCount: number, choice: string, activityId: string): void{
    this.getActiveEvents2().then( ev => {
      if(ev.size > 0){
        this.addEtoiles(userId,classId,etoilesCount,activityId,parseInt(choice, 10), ev.docs[0].id);
      }else{
        this.addEtoiles(userId,classId,etoilesCount,activityId,parseInt(choice, 10), '');
      }
    });
  }
  updateStarsForClass(userId: string, classeId: string, etoilesCount: number, activityId: string): void{
    this.afs.collection('classes').doc(classeId).update({
      medailles_count: firebase.default.firestore.FieldValue.increment(etoilesCount),
      ['cumul_par_activites.' + activityId]: firebase.default.firestore.FieldValue.increment(etoilesCount),
    }).then( () => {
      if (etoilesCount > 1){
        this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoiles`, 3000);
      }else{
        this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoile`, 3000);
      }
    });
    this.updateTempForClass(userId, classeId, etoilesCount,activityId);
  }
  updateTempForClass(userId: string, classId: string, etoilesCount: number, activityId: string){
    this.getActiveEvents2().then( ev => {
      if(ev.size > 0){
        this.addEtoiles(userId,classId,etoilesCount,activityId,3, ev.docs[0].id);
      }else{
        this.addEtoiles(userId,classId,etoilesCount,activityId,3, '');
      }
    });
  }
  updateStarsForRegion(userId: string, etoilesCount: number, activityId: string): void{
    this.afs.collection('utilisateurs').doc(userId).get().forEach( res => {
      this.afs.collection('ecoles').doc(res.data()['ecole_id']).get().forEach( res2 => {
        this.afs.collection('regions').doc(res2.data()['region_id']).update({
          medailles: firebase.default.firestore.FieldValue.increment(etoilesCount),
          ['cumul_par_activites.' + activityId]: firebase.default.firestore.FieldValue.increment(etoilesCount),
        }).then( () => {
          if (etoilesCount > 1){
            this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoiles`, 3000);
          }else{
            this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoile`, 3000);
          }
        });
      });
    });
  }
  updateStarsForEcole(ecoleId: string, etoilesCount: number, activityId: string): void{
    this.afs.collection('ecoles').doc(ecoleId).update({
      medailles: firebase.default.firestore.FieldValue.increment(etoilesCount),
      ['cumul_par_activites.' + activityId]: firebase.default.firestore.FieldValue.increment(etoilesCount),
    }).then( () => {
      if (etoilesCount > 1){
        this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoiles`, 3000);
      }else{
        this.showMessage(1, `Vous avez gagné ${etoilesCount.toFixed(1)} étoile`, 3000);
      }
    });
  }
}
